var projectTimeline = {
	"Project timeline": "Zeitplan des Projekts",
	"None planned": "Nichts geplant",
	"1-3 months": "1–3 Monate",
	"4-6 months": "4–6 Monate",
	"7-12 months": "7–12 Monate",
	"More than 1 year": "Mehr als ein Jahr"
};

export { projectTimeline as default };
